module.exports = __webpack_public_path__ + "img/stu-topic-info-2.5327eadb.svg";